module.exports = __webpack_public_path__ + "img/121-34492d.png";